<template>
  <div class="misc">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="admins"
      class="layout"
    >
      <br>
      <div class="flex collapse">
        <h2>Admins</h2>
        <ChevronUpIcon class="icone" @click="toggleAdmins" v-if="showAdmins" />
        <ChevronDownIcon class="icone" @click="toggleAdmins" v-if="!showAdmins" />
      </div>
      <div v-if="showAdmins">
        <div
          v-for="admin in admins"
          :key="admin.uid"
        >
          <SchoolRecords :record="admin" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="card"
    >
      <Spinner />
    </div>
  </div>
</template>

<script>
import getListOfUsers from '@/composables/getListOfUsers'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/outline'
import SchoolRecords from './SchoolRecords.vue'
import Spinner from '@/components/Spinner.vue'
import { ref } from '@vue/reactivity'

export default {
  name: 'AdminRecords',
  components: { SchoolRecords, Spinner, ChevronDownIcon, ChevronUpIcon },
  setup () {
    const showAdmins = ref(false)
    const { admins, error, fetchListOfUsers } = getListOfUsers()

    fetchListOfUsers()

    const toggleAdmins = () => {
      showAdmins.value = !showAdmins.value
    }

    return { admins, error, showAdmins, toggleAdmins }
  }
}
</script>

<style>
.misc .collapse {
  justify-content: space-between;
}
.misc .icone {
  max-width: 30px;
  cursor: pointer;
  color: white;
}
</style>
